import React from "react";

export const Label = ({ children, className, onClick, ...props }) => {
  return (
    <label className={className} onClick={onClick} {...props}>
      {children}
    </label>
  );
};
